export const CONTENTCATEGORY_LOADING = "CONTENTCATEGORY_LOADING";
export const CONTENTCATEGORY_RESET = "CONTENTCATEGORY_RESET";
export const GET_CONTENTCATEGORY = "GET_CONTENTCATEGORY";
export const GET_CONTENTCATEGORY_SUCCESS = "GET_CONTENTCATEGORY_SUCCESS";
export const GET_CONTENTCATEGORY_FAIL = "GET_CONTENTCATEGORY_FAIL";
export const DELETE_CONTENTCATEGORY = "DELETE_CONTENTCATEGORY"
export const DELETE_CONTENTCATEGORY_SUCCESS = "DELETE_CONTENTCATEGORY_SUCCESS"
export const DELETE_CONTENTCATEGORY_FAIL = "DELETE_CONTENTCATEGORY_FAIL"
export const UPDATE_CONTENTCATEGORY = "UPDATE_CONTENTCATEGORY"
export const UPDATE_CONTENTCATEGORY_SUCCESS = "UPDATE_CONTENTCATEGORY_SUCCESS"
export const UPDATE_CONTENTCATEGORY_FAIL = "UPDATE_CONTENTCATEGORY_FAIL"
export const ADD_NEW_CONTENTCATEGORY = "ADD_NEW_CONTENTCATEGORY"
export const ADD_CONTENTCATEGORY_SUCCESS = "ADD_CONTENTCATEGORY_SUCCESS"
export const ADD_CONTENTCATEGORY_FAIL = "ADD_CONTENTCATEGORY_FAIL"